import type { PlayerColor } from '@/shared/board/types'
import type { MoveOption } from './placement'

/**
 * Ходы выбранной фишки — кнопками под палец.
 *
 * Зона нажатия на доске остаётся как была, но её мало: цели ходов часто стоят
 * на соседних клетках, и тогда каждой достаётся ровно клетка — около 14
 * пикселей. Здесь те же ходы лежат кнопками, и партию можно доиграть, ни разу
 * не попав в клетку.
 *
 * Чипы не заменяют метки на доске: по метке видно КУДА, по чипу — ЧТО. Одно
 * без другого работает хуже.
 */

/** Цвета в винительном падеже: «рубить зелёную». */
const VICTIM: Record<PlayerColor, string> = {
  red: 'красную',
  green: 'зелёную',
  yellow: 'жёлтую',
  blue: 'синюю',
}

/**
 * Подпись хода.
 *
 * В подписи рубки стоит ЦВЕТ, а не ник: цвет виден на самой клетке, а ник
 * пришлось бы сверять с карточками — и вчетвером на клетке может оказаться
 * кто угодно.
 *
 * Ход на сумму рубит и двоих: тогда цвета не помещаются, и остаётся число.
 *
 * Подписи короткие не от лени: три чипа обязаны встать в строку на 390
 * пикселях, иначе третий обрезается. Полную фразу получает читалка —
 * она уже собрана для метки на доске (option.hint).
 */
function label(option: MoveOption): string {
  if (option.victims.length > 1) return `рубить ${option.victims.length}`
  if (option.victims.length === 1) return `рубить ${VICTIM[option.victims[0]]}`
  if (option.jump) return 'угол'
  if (option.steps.some((step) => step.kind === 'exit')) return 'из двора'

  return 'вперёд'
}

type Props = {
  options: MoveOption[]
  onPick: (key: string) => void
}

export function MoveChips({ options, onPick }: Props) {
  return (
    <div className="act act--moves">
      {options.map((option) => {
        const marks = [
          'act__chip',
          option.victims.length > 0 ? 'act__chip--eat' : '',
          option.jump ? 'act__chip--jump' : '',
        ]

        return (
          <button
            key={option.key}
            className={marks.filter(Boolean).join(' ')}
            type="button"
            // Полная фраза — читалке: она уже собрана для метки на доске,
            // и второй раз её сочинять незачем.
            aria-label={option.hint}
            onClick={() => onPick(option.key)}
          >
            <b>{option.jump ? '↷' : option.pips}</b> {label(option)}
          </button>
        )
      })}
    </div>
  )
}
